var KML_2_2_0_Module_Factory = function () {
  var KML_2_2_0 = {
    n: 'KML_2_2_0',
    dens: 'http:\/\/www.opengis.net\/kml\/2.2',
    deps: ['xAL_2_0', 'Atom_1_0'],
    tis: [{
        ln: 'ChangeType',
        ps: [{
            n: 'abstractObjectGroup',
            mno: 0,
            col: true,
            mx: false,
            dom: false,
            en: 'AbstractObjectGroup',
            ti: '.AbstractObjectType',
            t: 'er'
          }]
      }, {
        ln: 'LineStyleType',
        bti: '.AbstractColorStyleType',
        ps: [{
            n: 'width',
            ti: 'Double'
          }, {
            n: 'lineStyleSimpleExtensionGroup',
            mno: 0,
            col: true,
            en: 'LineStyleSimpleExtensionGroup',
            ti: 'AnySimpleType'
          }, {
            n: 'lineStyleObjectExtensionGroup',
            mno: 0,
            col: true,
            en: 'LineStyleObjectExtensionGroup',
            ti: '.AbstractObjectType'
          }]
      }, {
        ln: 'OrientationType',
        bti: '.AbstractObjectType',
        ps: [{
            n: 'heading',
            ti: 'Double'
          }, {
            n: 'tilt',
            ti: 'Double'
          }, {
            n: 'roll',
            ti: 'Double'
          }, {
            n: 'orientationSimpleExtensionGroup',
            mno: 0,
            col: true,
            en: 'OrientationSimpleExtensionGroup',
            ti: 'AnySimpleType'
          }, {
            n: 'orientationObjectExtensionGroup',
            mno: 0,
            col: true,
            en: 'OrientationObjectExtensionGroup',
            ti: '.AbstractObjectType'
          }]
      }, {
        ln: 'AbstractContainerType',
        bti: '.AbstractFeatureType',
        ps: [{
            n: 'abstractContainerSimpleExtensionGroup',
            mno: 0,
            col: true,
            en: 'AbstractContainerSimpleExtensionGroup',
            ti: 'AnySimpleType'
          }, {
            n: 'abstractContainerObjectExtensionGroup',
            mno: 0,
            col: true,
            en: 'AbstractContainerObjectExtensionGroup',
            ti: '.AbstractObjectType'
          }]
      }, {
        ln: 'DocumentType',
        bti: '.AbstractContainerType',
        ps: [{
            n: 'schema',
            mno: 0,
            col: true,
            en: 'Schema',
            ti: '.SchemaType'
          }, {
            n: 'abstractFeatureGroup',
            mno: 0,
            col: true,
            mx: false,
            dom: false,
            en: 'AbstractFeatureGroup',
            ti: '.AbstractFeatureType',
            t: 'er'
          }, {
            n: 'documentSimpleExtensionGroup',
            mno: 0,
            col: true,
            en: 'DocumentSimpleExtensionGroup',
            ti: 'AnySimpleType'
          }, {
            n: 'documentObjectExtensionGroup',
            mno: 0,
            col: true,
            en: 'DocumentObjectExtensionGroup',
            ti: '.AbstractObjectType'
          }]
      }, {
        ln: 'KmlType',
        ps: [{
            n: 'networkLinkControl',
            en: 'NetworkLinkControl',
            ti: '.NetworkLinkControlType'
          }, {
            n: 'abstractFeatureGroup',
            mx: false,
            dom: false,
            en: 'AbstractFeatureGroup',
            ti: '.AbstractFeatureType',
            t: 'er'
          }, {
            n: 'kmlSimpleExtensionGroup',
            mno: 0,
            col: true,
            en: 'KmlSimpleExtensionGroup',
            ti: 'AnySimpleType'
          }, {
            n: 'kmlObjectExtensionGroup',
            mno: 0,
            col: true,
            en: 'KmlObjectExtensionGroup',
            ti: '.AbstractObjectType'
          }, {
            n: 'hint',
            an: {
              lp: 'hint'
            },
            t: 'a'
          }]
      }, {
        ln: 'LinearRingType',
        bti: '.AbstractGeometryType',
        ps: [{
            n: 'extrude',
            ti: 'Boolean'
          }, {
            n: 'tessellate',
            ti: 'Boolean'
          }, {
            n: 'altitudeModeGroup',
            mx: false,
            dom: false,
            ti: 'AnyType',
            t: 'er'
          }, {
            n: 'coordinates',
            ti: {
              t: 'l'
            }
          }, {
            n: 'linearRingSimpleExtensionGroup',
            mno: 0,
            col: true,
            en: 'LinearRingSimpleExtensionGroup',
            ti: 'AnySimpleType'
          }, {
            n: 'linearRingObjectExtensionGroup',
            mno: 0,
            col: true,
            en: 'LinearRingObjectExtensionGroup',
            ti: '.AbstractObjectType'
          }]
      }, {
        ln: 'NetworkLinkType',
        bti: '.AbstractFeatureType',
        ps: [{
            n: 'refreshVisibility',
            ti: 'Boolean'
          }, {
            n: 'flyToView',
            ti: 'Boolean'
          }, {
            n: 'url',
            en: 'Url',
            ti: '.LinkType'
          }, {
            n: 'link',
            en: 'Link',
            ti: '.LinkType'
          }, {
            n: 'networkLinkSimpleExtensionGroup',
            mno: 0,
            col: true,
            en: 'NetworkLinkSimpleExtensionGroup',
            ti: 'AnySimpleType'
          }, {
            n: 'networkLinkObjectExtensionGroup',
            mno: 0,
            col: true,
            en: 'NetworkLinkObjectExtensionGroup',
            ti: '.AbstractObjectType'
          }]
      }, {
        ln: 'AbstractGeometryType',
        bti: '.AbstractObjectType',
        ps: [{
            n: 'abstractGeometrySimpleExtensionGroup',
            mno: 0,
            col: true,
            en: 'AbstractGeometrySimpleExtensionGroup',
            ti: 'AnySimpleType'
          }, {
            n: 'abstractGeometryObjectExtensionGroup',
            mno: 0,
            col: true,
            en: 'AbstractGeometryObjectExtensionGroup',
            ti: '.AbstractObjectType'
          }]
      }, {
        ln: 'ScaleType',
        bti: '.AbstractObjectType',
        ps: [{
            n: 'x',
            ti: 'Double'
          }, {
            n: 'y',
            ti: 'Double'
          }, {
            n: 'z',
            ti: 'Double'
          }, {
            n: 'scaleSimpleExtensionGroup',
            mno: 0,
            col: true,
            en: 'ScaleSimpleExtensionGroup',
            ti: 'AnySimpleType'
          }, {
            n: 'scaleObjectExtensionGroup',
            mno: 0,
            col: true,
            en: 'ScaleObjectExtensionGroup',
            ti: '.AbstractObjectType'
          }]
      }, {
        ln: 'AbstractObjectType',
        ps: [{
            n: 'objectSimpleExtensionGroup',
            mno: 0,
            col: true,
            en: 'ObjectSimpleExtensionGroup',
            ti: 'AnySimpleType'
          }, {
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id'
            },
            t: 'a'
          }, {
            n: 'targetId',
            ti: 'NCName',
            an: {
              lp: 'targetId'
            },
            t: 'a'
          }]
      }, {
        ln: 'NetworkLinkControlType',
        ps: [{
            n: 'minRefreshPeriod',
            ti: 'Double'
          }, {
            n: 'maxSessionLength',
            ti: 'Double'
          }, {
            n: 'cookie'
          }, {
            n: 'message'
          }, {
            n: 'linkName'
          }, {
            n: 'linkDescription'
          }, {
            n: 'linkSnippet',
            ti: '.SnippetType'
          }, {
            n: 'expires'
          }, {
            n: 'update',
            en: 'Update',
            ti: '.UpdateType'
          }, {
            n: 'abstractViewGroup',
            mx: false,
            dom: false,
            en: 'AbstractViewGroup',
            ti: '.AbstractViewType',
            t: 'er'
          }, {
            n: 'networkLinkControlSimpleExtensionGroup',
            mno: 0,
            col: true,
            en: 'NetworkLinkControlSimpleExtensionGroup',
            ti: 'AnySimpleType'
          }, {
            n: 'networkLinkControlObjectExtensionGroup',
            mno: 0,
            col: true,
            en: 'NetworkLinkControlObjectExtensionGroup',
            ti: '.AbstractObjectType'
          }]
      }, {
        ln: 'ExtendedDataType',
        ps: [{
            n: 'data',
            mno: 0,
            col: true,
            en: 'Data',
            ti: '.DataType'
          }, {
            n: 'schemaData',
            mno: 0,
            col: true,
            en: 'SchemaData',
            ti: '.SchemaDataType'
          }, {
            n: 'any',
            mno: 0,
            col: true,
            mx: false,
            t: 'ae'
          }]
      }, {
        ln: 'PairType',
        bti: '.AbstractObjectType',
        ps: [{
            n: 'key'
          }, {
            n: 'styleUrl'
          }, {
            n: 'abstractStyleSelectorGroup',
            mx: false,
            dom: false,
            en: 'AbstractStyleSelectorGroup',
            ti: '.AbstractStyleSelectorType',
            t: 'er'
          }, {
            n: 'pairSimpleExtensionGroup',
            mno: 0,
            col: true,
            en: 'PairSimpleExtensionGroup',
            ti: 'AnySimpleType'
          }, {
            n: 'pairObjectExtensionGroup',
            mno: 0,
            col: true,
            en: 'PairObjectExtensionGroup',
            ti: '.AbstractObjectType'
          }]
      }, {
        ln: 'LookAtType',
        bti: '.AbstractViewType',
        ps: [{
            n: 'longitude',
            ti: 'Double'
          }, {
            n: 'latitude',
            ti: 'Double'
          }, {
            n: 'altitude',
            ti: 'Double'
          }, {
            n: 'heading',
            ti: 'Double'
          }, {
            n: 'tilt',
            ti: 'Double'
          }, {
            n: 'range',
            ti: 'Double'
          }, {
            n: 'altitudeModeGroup',
            mx: false,
            dom: false,
            ti: 'AnyType',
            t: 'er'
          }, {
            n: 'lookAtSimpleExtensionGroup',
            mno: 0,
            col: true,
            en: 'LookAtSimpleExtensionGroup',
            ti: 'AnySimpleType'
          }, {
            n: 'lookAtObjectExtensionGroup',
            mno: 0,
            col: true,
            en: 'LookAtObjectExtensionGroup',
            ti: '.AbstractObjectType'
          }]
      }, {
        ln: 'LodType',
        bti: '.AbstractObjectType',
        ps: [{
            n: 'minLodPixels',
            ti: 'Double'
          }, {
            n: 'maxLodPixels',
            ti: 'Double'
          }, {
            n: 'minFadeExtent',
            ti: 'Double'
          }, {
            n: 'maxFadeExtent',
            ti: 'Double'
          }, {
            n: 'lodSimpleExtensionGroup',
            mno: 0,
            col: true,
            en: 'LodSimpleExtensionGroup',
            ti: 'AnySimpleType'
          }, {
            n: 'lodObjectExtensionGroup',
            mno: 0,
            col: true,
            en: 'LodObjectExtensionGroup',
            ti: '.AbstractObjectType'
          }]
      }, {
        ln: 'StyleMapType',
        bti: '.AbstractStyleSelectorType',
        ps: [{
            n: 'pair',
            mno: 0,
            col: true,
            en: 'Pair',
            ti: '.PairType'
          }, {
            n: 'styleMapSimpleExtensionGroup',
            mno: 0,
            col: true,
            en: 'StyleMapSimpleExtensionGroup',
            ti: 'AnySimpleType'
          }, {
            n: 'styleMapObjectExtensionGroup',
            mno: 0,
            col: true,
            en: 'StyleMapObjectExtensionGroup',
            ti: '.AbstractObjectType'
          }]
      }, {
        ln: 'AbstractLatLonBoxType',
        bti: '.AbstractObjectType',
        ps: [{
            n: 'north',
            ti: 'Double'
          }, {
            n: 'south',
            ti: 'Double'
          }, {
            n: 'east',
            ti: 'Double'
          }, {
            n: 'west',
            ti: 'Double'
          }, {
            n: 'abstractLatLonBoxSimpleExtensionGroup',
            mno: 0,
            col: true,
            en: 'AbstractLatLonBoxSimpleExtensionGroup',
            ti: 'AnySimpleType'
          }, {
            n: 'abstractLatLonBoxObjectExtensionGroup',
            mno: 0,
            col: true,
            en: 'AbstractLatLonBoxObjectExtensionGroup',
            ti: '.AbstractObjectType'
          }]
      }, {
        ln: 'PlacemarkType',
        bti: '.AbstractFeatureType',
        ps: [{
            n: 'abstractGeometryGroup',
            mx: false,
            dom: false,
            en: 'AbstractGeometryGroup',
            ti: '.AbstractGeometryType',
            t: 'er'
          }, {
            n: 'placemarkSimpleExtensionGroup',
            mno: 0,
            col: true,
            en: 'PlacemarkSimpleExtensionGroup',
            ti: 'AnySimpleType'
          }, {
            n: 'placemarkObjectExtensionGroup',
            mno: 0,
            col: true,
            en: 'PlacemarkObjectExtensionGroup',
            ti: '.AbstractObjectType'
          }]
      }, {
        ln: 'SimpleDataType',
        ps: [{
            n: 'value',
            t: 'v'
          }, {
            n: 'name',
            rq: true,
            an: {
              lp: 'name'
            },
            t: 'a'
          }]
      }, {
        ln: 'AbstractOverlayType',
        bti: '.AbstractFeatureType',
        ps: [{
            n: 'color',
            ti: 'HexBinary'
          }, {
            n: 'drawOrder',
            ti: 'Int'
          }, {
            n: 'icon',
            en: 'Icon',
            ti: '.LinkType'
          }, {
            n: 'abstractOverlaySimpleExtensionGroup',
            mno: 0,
            col: true,
            en: 'AbstractOverlaySimpleExtensionGroup',
            ti: 'AnySimpleType'
          }, {
            n: 'abstractOverlayObjectExtensionGroup',
            mno: 0,
            col: true,
            en: 'AbstractOverlayObjectExtensionGroup',
            ti: '.AbstractObjectType'
          }]
      }, {
        ln: 'DataType',
        bti: '.AbstractObjectType',
        ps: [{
            n: 'displayName'
          }, {
            n: 'value',
            rq: true
          }, {
            n: 'dataExtension',
            mno: 0,
            col: true,
            en: 'DataExtension',
            ti: 'AnyType'
          }, {
            n: 'name',
            an: {
              lp: 'name'
            },
            t: 'a'
          }]
      }, {
        ln: 'AliasType',
        bti: '.AbstractObjectType',
        ps: [{
            n: 'targetHref'
          }, {
            n: 'sourceHref'
          }, {
            n: 'aliasSimpleExtensionGroup',
            mno: 0,
            col: true,
            en: 'AliasSimpleExtensionGroup',
            ti: 'AnySimpleType'
          }, {
            n: 'aliasObjectExtensionGroup',
            mno: 0,
            col: true,
            en: 'AliasObjectExtensionGroup',
            ti: '.AbstractObjectType'
          }]
      }, {
        ln: 'LatLonBoxType',
        bti: '.AbstractLatLonBoxType',
        ps: [{
            n: 'rotation',
            ti: 'Double'
          }, {
            n: 'latLonBoxSimpleExtensionGroup',
            mno: 0,
            col: true,
            en: 'LatLonBoxSimpleExtensionGroup',
            ti: 'AnySimpleType'
          }, {
            n: 'latLonBoxObjectExtensionGroup',
            mno: 0,
            col: true,
            en: 'LatLonBoxObjectExtensionGroup',
            ti: '.AbstractObjectType'
          }]
      }, {
        ln: 'DeleteType',
        ps: [{
            n: 'abstractFeatureGroup',
            mno: 0,
            col: true,
            mx: false,
            dom: false,
            en: 'AbstractFeatureGroup',
            ti: '.AbstractFeatureType',
            t: 'er'
          }]
      }, {
        ln: 'RegionType',
        bti: '.AbstractObjectType',
        ps: [{
            n: 'latLonAltBox',
            en: 'LatLonAltBox',
            ti: '.LatLonAltBoxType'
          }, {
            n: 'lod',
            en: 'Lod',
            ti: '.LodType'
          }, {
            n: 'regionSimpleExtensionGroup',
            mno: 0,
            col: true,
            en: 'RegionSimpleExtensionGroup',
            ti: 'AnySimpleType'
          }, {
            n: 'regionObjectExtensionGroup',
            mno: 0,
            col: true,
            en: 'RegionObjectExtensionGroup',
            ti: '.AbstractObjectType'
          }]
      }, {
        ln: 'BasicLinkType',
        bti: '.AbstractObjectType',
        ps: [{
            n: 'href'
          }, {
            n: 'basicLinkSimpleExtensionGroup',
            mno: 0,
            col: true,
            en: 'BasicLinkSimpleExtensionGroup',
            ti: 'AnySimpleType'
          }, {
            n: 'basicLinkObjectExtensionGroup',
            mno: 0,
            col: true,
            en: 'BasicLinkObjectExtensionGroup',
            ti: '.AbstractObjectType'
          }]
      }, {
        ln: 'PointType',
        bti: '.AbstractGeometryType',
        ps: [{
            n: 'extrude',
            ti: 'Boolean'
          }, {
            n: 'altitudeModeGroup',
            mx: false,
            dom: false,
            ti: 'AnyType',
            t: 'er'
          }, {
            n: 'coordinates',
            ti: {
              t: 'l'
            }
          }, {
            n: 'pointSimpleExtensionGroup',
            mno: 0,
            col: true,
            en: 'PointSimpleExtensionGroup',
            ti: 'AnySimpleType'
          }, {
            n: 'pointObjectExtensionGroup',
            mno: 0,
            col: true,
            en: 'PointObjectExtensionGroup',
            ti: '.AbstractObjectType'
          }]
      }, {
        ln: 'ResourceMapType',
        bti: '.AbstractObjectType',
        ps: [{
            n: 'alias',
            mno: 0,
            col: true,
            en: 'Alias',
            ti: '.AliasType'
          }, {
            n: 'resourceMapSimpleExtensionGroup',
            mno: 0,
            col: true,
            en: 'ResourceMapSimpleExtensionGroup',
            ti: 'AnySimpleType'
          }, {
            n: 'resourceMapObjectExtensionGroup',
            mno: 0,
            col: true,
            en: 'ResourceMapObjectExtensionGroup',
            ti: '.AbstractObjectType'
          }]
      }, {
        ln: 'SnippetType',
        ps: [{
            n: 'value',
            t: 'v'
          }, {
            n: 'maxLines',
            ti: 'Int',
            an: {
              lp: 'maxLines'
            },
            t: 'a'
          }]
      }, {
        ln: 'MetadataType',
        ps: [{
            n: 'any',
            mno: 0,
            col: true,
            mx: false,
            t: 'ae'
          }]
      }, {
        ln: 'BoundaryType',
        ps: [{
            n: 'linearRing',
            en: 'LinearRing',
            ti: '.LinearRingType'
          }, {
            n: 'boundarySimpleExtensionGroup',
            mno: 0,
            col: true,
            en: 'BoundarySimpleExtensionGroup',
            ti: 'AnySimpleType'
          }, {
            n: 'boundaryObjectExtensionGroup',
            mno: 0,
            col: true,
            en: 'BoundaryObjectExtensionGroup',
            ti: '.AbstractObjectType'
          }]
      }, {
        ln: 'ScreenOverlayType',
        bti: '.AbstractOverlayType',
        ps: [{
            n: 'overlayXY',
            ti: '.Vec2Type'
          }, {
            n: 'screenXY',
            ti: '.Vec2Type'
          }, {
            n: 'rotationXY',
            ti: '.Vec2Type'
          }, {
            n: 'size',
            ti: '.Vec2Type'
          }, {
            n: 'rotation',
            ti: 'Double'
          }, {
            n: 'screenOverlaySimpleExtensionGroup',
            mno: 0,
            col: true,
            en: 'ScreenOverlaySimpleExtensionGroup',
            ti: 'AnySimpleType'
          }, {
            n: 'screenOverlayObjectExtensionGroup',
            mno: 0,
            col: true,
            en: 'ScreenOverlayObjectExtensionGroup',
            ti: '.AbstractObjectType'
          }]
      }, {
        ln: 'LineStringType',
        bti: '.AbstractGeometryType',
        ps: [{
            n: 'extrude',
            ti: 'Boolean'
          }, {
            n: 'tessellate',
            ti: 'Boolean'
          }, {
            n: 'altitudeModeGroup',
            mx: false,
            dom: false,
            ti: 'AnyType',
            t: 'er'
          }, {
            n: 'coordinates',
            ti: {
              t: 'l'
            }
          }, {
            n: 'lineStringSimpleExtensionGroup',
            mno: 0,
            col: true,
            en: 'LineStringSimpleExtensionGroup',
            ti: 'AnySimpleType'
          }, {
            n: 'lineStringObjectExtensionGroup',
            mno: 0,
            col: true,
            en: 'LineStringObjectExtensionGroup',
            ti: '.AbstractObjectType'
          }]
      }, {
        ln: 'MultiGeometryType',
        bti: '.AbstractGeometryType',
        ps: [{
            n: 'abstractGeometryGroup',
            mno: 0,
            col: true,
            mx: false,
            dom: false,
            en: 'AbstractGeometryGroup',
            ti: '.AbstractGeometryType',
            t: 'er'
          }, {
            n: 'multiGeometrySimpleExtensionGroup',
            mno: 0,
            col: true,
            en: 'MultiGeometrySimpleExtensionGroup',
            ti: 'AnySimpleType'
          }, {
            n: 'multiGeometryObjectExtensionGroup',
            mno: 0,
            col: true,
            en: 'MultiGeometryObjectExtensionGroup',
            ti: '.AbstractObjectType'
          }]
      }, {
        ln: 'FolderType',
        bti: '.AbstractContainerType',
        ps: [{
            n: 'abstractFeatureGroup',
            mno: 0,
            col: true,
            mx: false,
            dom: false,
            en: 'AbstractFeatureGroup',
            ti: '.AbstractFeatureType',
            t: 'er'
          }, {
            n: 'folderSimpleExtensionGroup',
            mno: 0,
            col: true,
            en: 'FolderSimpleExtensionGroup',
            ti: 'AnySimpleType'
          }, {
            n: 'folderObjectExtensionGroup',
            mno: 0,
            col: true,
            en: 'FolderObjectExtensionGroup',
            ti: '.AbstractObjectType'
          }]
      }, {
        ln: 'TimeSpanType',
        bti: '.AbstractTimePrimitiveType',
        ps: [{
            n: 'begin'
          }, {
            n: 'end'
          }, {
            n: 'timeSpanSimpleExtensionGroup',
            mno: 0,
            col: true,
            en: 'TimeSpanSimpleExtensionGroup',
            ti: 'AnySimpleType'
          }, {
            n: 'timeSpanObjectExtensionGroup',
            mno: 0,
            col: true,
            en: 'TimeSpanObjectExtensionGroup',
            ti: '.AbstractObjectType'
          }]
      }, {
        ln: 'ListStyleType',
        bti: '.AbstractSubStyleType',
        ps: [{
            n: 'listItemType'
          }, {
            n: 'bgColor',
            ti: 'HexBinary'
          }, {
            n: 'itemIcon',
            mno: 0,
            col: true,
            en: 'ItemIcon',
            ti: '.ItemIconType'
          }, {
            n: 'maxSnippetLines',
            ti: 'Int'
          }, {
            n: 'listStyleSimpleExtensionGroup',
            mno: 0,
            col: true,
            en: 'ListStyleSimpleExtensionGroup',
            ti: 'AnySimpleType'
          }, {
            n: 'listStyleObjectExtensionGroup',
            mno: 0,
            col: true,
            en: 'ListStyleObjectExtensionGroup',
            ti: '.AbstractObjectType'
          }]
      }, {
        ln: 'ItemIconType',
        bti: '.AbstractObjectType',
        ps: [{
            n: 'state',
            ti: {
              t: 'l'
            }
          }, {
            n: 'href'
          }, {
            n: 'itemIconSimpleExtensionGroup',
            mno: 0,
            col: true,
            en: 'ItemIconSimpleExtensionGroup',
            ti: 'AnySimpleType'
          }, {
            n: 'itemIconObjectExtensionGroup',
            mno: 0,
            col: true,
            en: 'ItemIconObjectExtensionGroup',
            ti: '.AbstractObjectType'
          }]
      }, {
        ln: 'LabelStyleType',
        bti: '.AbstractColorStyleType',
        ps: [{
            n: 'scale',
            ti: 'Double'
          }, {
            n: 'labelStyleSimpleExtensionGroup',
            mno: 0,
            col: true,
            en: 'LabelStyleSimpleExtensionGroup',
            ti: 'AnySimpleType'
          }, {
            n: 'labelStyleObjectExtensionGroup',
            mno: 0,
            col: true,
            en: 'LabelStyleObjectExtensionGroup',
            ti: '.AbstractObjectType'
          }]
      }, {
        ln: 'AbstractViewType',
        bti: '.AbstractObjectType',
        ps: [{
            n: 'abstractViewSimpleExtensionGroup',
            mno: 0,
            col: true,
            en: 'AbstractViewSimpleExtensionGroup',
            ti: 'AnySimpleType'
          }, {
            n: 'abstractViewObjectExtensionGroup',
            mno: 0,
            col: true,
            en: 'AbstractViewObjectExtensionGroup',
            ti: '.AbstractObjectType'
          }]
      }, {
        ln: 'AbstractStyleSelectorType',
        bti: '.AbstractObjectType',
        ps: [{
            n: 'abstractStyleSelectorSimpleExtensionGroup',
            mno: 0,
            col: true,
            en: 'AbstractStyleSelectorSimpleExtensionGroup',
            ti: 'AnySimpleType'
          }, {
            n: 'abstractStyleSelectorObjectExtensionGroup',
            mno: 0,
            col: true,
            en: 'AbstractStyleSelectorObjectExtensionGroup',
            ti: '.AbstractObjectType'
          }]
      }, {
        ln: 'LocationType',
        bti: '.AbstractObjectType',
        ps: [{
            n: 'longitude',
            ti: 'Double'
          }, {
            n: 'latitude',
            ti: 'Double'
          }, {
            n: 'altitude',
            ti: 'Double'
          }, {
            n: 'locationSimpleExtensionGroup',
            mno: 0,
            col: true,
            en: 'LocationSimpleExtensionGroup',
            ti: 'AnySimpleType'
          }, {
            n: 'locationObjectExtensionGroup',
            mno: 0,
            col: true,
            en: 'LocationObjectExtensionGroup',
            ti: '.AbstractObjectType'
          }]
      }, {
        ln: 'CameraType',
        bti: '.AbstractViewType',
        ps: [{
            n: 'longitude',
            ti: 'Double'
          }, {
            n: 'latitude',
            ti: 'Double'
          }, {
            n: 'altitude',
            ti: 'Double'
          }, {
            n: 'heading',
            ti: 'Double'
          }, {
            n: 'tilt',
            ti: 'Double'
          }, {
            n: 'roll',
            ti: 'Double'
          }, {
            n: 'altitudeModeGroup',
            mx: false,
            dom: false,
            ti: 'AnyType',
            t: 'er'
          }, {
            n: 'cameraSimpleExtensionGroup',
            mno: 0,
            col: true,
            en: 'CameraSimpleExtensionGroup',
            ti: 'AnySimpleType'
          }, {
            n: 'cameraObjectExtensionGroup',
            mno: 0,
            col: true,
            en: 'CameraObjectExtensionGroup',
            ti: '.AbstractObjectType'
          }]
      }, {
        ln: 'ModelType',
        bti: '.AbstractGeometryType',
        ps: [{
            n: 'altitudeModeGroup',
            mx: false,
            dom: false,
            ti: 'AnyType',
            t: 'er'
          }, {
            n: 'location',
            en: 'Location',
            ti: '.LocationType'
          }, {
            n: 'orientation',
            en: 'Orientation',
            ti: '.OrientationType'
          }, {
            n: 'scale',
            en: 'Scale',
            ti: '.ScaleType'
          }, {
            n: 'link',
            en: 'Link',
            ti: '.LinkType'
          }, {
            n: 'resourceMap',
            en: 'ResourceMap',
            ti: '.ResourceMapType'
          }, {
            n: 'modelSimpleExtensionGroup',
            mno: 0,
            col: true,
            en: 'ModelSimpleExtensionGroup',
            ti: 'AnySimpleType'
          }, {
            n: 'modelObjectExtensionGroup',
            mno: 0,
            col: true,
            en: 'ModelObjectExtensionGroup',
            ti: '.AbstractObjectType'
          }]
      }, {
        ln: 'SchemaType',
        ps: [{
            n: 'simpleField',
            mno: 0,
            col: true,
            en: 'SimpleField',
            ti: '.SimpleFieldType'
          }, {
            n: 'schemaExtension',
            mno: 0,
            col: true,
            en: 'SchemaExtension',
            ti: 'AnyType'
          }, {
            n: 'name',
            an: {
              lp: 'name'
            },
            t: 'a'
          }, {
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id'
            },
            t: 'a'
          }]
      }, {
        ln: 'CreateType',
        ps: [{
            n: 'abstractContainerGroup',
            mno: 0,
            col: true,
            mx: false,
            dom: false,
            en: 'AbstractContainerGroup',
            ti: '.AbstractContainerType',
            t: 'er'
          }]
      }, {
        ln: 'SimpleFieldType',
        ps: [{
            n: 'displayName'
          }, {
            n: 'simpleFieldExtension',
            mno: 0,
            col: true,
            en: 'SimpleFieldExtension',
            ti: 'AnyType'
          }, {
            n: 'type',
            an: {
              lp: 'type'
            },
            t: 'a'
          }, {
            n: 'name',
            an: {
              lp: 'name'
            },
            t: 'a'
          }]
      }, {
        ln: 'PolygonType',
        bti: '.AbstractGeometryType',
        ps: [{
            n: 'extrude',
            ti: 'Boolean'
          }, {
            n: 'tessellate',
            ti: 'Boolean'
          }, {
            n: 'altitudeModeGroup',
            mx: false,
            dom: false,
            ti: 'AnyType',
            t: 'er'
          }, {
            n: 'outerBoundaryIs',
            ti: '.BoundaryType'
          }, {
            n: 'innerBoundaryIs',
            mno: 0,
            col: true,
            ti: '.BoundaryType'
          }, {
            n: 'polygonSimpleExtensionGroup',
            mno: 0,
            col: true,
            en: 'PolygonSimpleExtensionGroup',
            ti: 'AnySimpleType'
          }, {
            n: 'polygonObjectExtensionGroup',
            mno: 0,
            col: true,
            en: 'PolygonObjectExtensionGroup',
            ti: '.AbstractObjectType'
          }]
      }, {
        ln: 'Vec2Type',
        tn: 'vec2Type',
        ps: [{
            n: 'x',
            ti: 'Double',
            an: {
              lp: 'x'
            },
            t: 'a'
          }, {
            n: 'y',
            ti: 'Double',
            an: {
              lp: 'y'
            },
            t: 'a'
          }, {
            n: 'xunits',
            an: {
              lp: 'xunits'
            },
            t: 'a'
          }, {
            n: 'yunits',
            an: {
              lp: 'yunits'
            },
            t: 'a'
          }]
      }, {
        ln: 'TimeStampType',
        bti: '.AbstractTimePrimitiveType',
        ps: [{
            n: 'when'
          }, {
            n: 'timeStampSimpleExtensionGroup',
            mno: 0,
            col: true,
            en: 'TimeStampSimpleExtensionGroup',
            ti: 'AnySimpleType'
          }, {
            n: 'timeStampObjectExtensionGroup',
            mno: 0,
            col: true,
            en: 'TimeStampObjectExtensionGroup',
            ti: '.AbstractObjectType'
          }]
      }, {
        ln: 'PolyStyleType',
        bti: '.AbstractColorStyleType',
        ps: [{
            n: 'fill',
            ti: 'Boolean'
          }, {
            n: 'outline',
            ti: 'Boolean'
          }, {
            n: 'polyStyleSimpleExtensionGroup',
            mno: 0,
            col: true,
            en: 'PolyStyleSimpleExtensionGroup',
            ti: 'AnySimpleType'
          }, {
            n: 'polyStyleObjectExtensionGroup',
            mno: 0,
            col: true,
            en: 'PolyStyleObjectExtensionGroup',
            ti: '.AbstractObjectType'
          }]
      }, {
        ln: 'LatLonAltBoxType',
        bti: '.AbstractLatLonBoxType',
        ps: [{
            n: 'minAltitude',
            ti: 'Double'
          }, {
            n: 'maxAltitude',
            ti: 'Double'
          }, {
            n: 'altitudeModeGroup',
            mx: false,
            dom: false,
            ti: 'AnyType',
            t: 'er'
          }, {
            n: 'latLonAltBoxSimpleExtensionGroup',
            mno: 0,
            col: true,
            en: 'LatLonAltBoxSimpleExtensionGroup',
            ti: 'AnySimpleType'
          }, {
            n: 'latLonAltBoxObjectExtensionGroup',
            mno: 0,
            col: true,
            en: 'LatLonAltBoxObjectExtensionGroup',
            ti: '.AbstractObjectType'
          }]
      }, {
        ln: 'AbstractTimePrimitiveType',
        bti: '.AbstractObjectType',
        ps: [{
            n: 'abstractTimePrimitiveSimpleExtensionGroup',
            mno: 0,
            col: true,
            en: 'AbstractTimePrimitiveSimpleExtensionGroup',
            ti: 'AnySimpleType'
          }, {
            n: 'abstractTimePrimitiveObjectExtensionGroup',
            mno: 0,
            col: true,
            en: 'AbstractTimePrimitiveObjectExtensionGroup',
            ti: '.AbstractObjectType'
          }]
      }, {
        ln: 'ImagePyramidType',
        bti: '.AbstractObjectType',
        ps: [{
            n: 'tileSize',
            ti: 'Int'
          }, {
            n: 'maxWidth',
            ti: 'Int'
          }, {
            n: 'maxHeight',
            ti: 'Int'
          }, {
            n: 'gridOrigin'
          }, {
            n: 'imagePyramidSimpleExtensionGroup',
            mno: 0,
            col: true,
            en: 'ImagePyramidSimpleExtensionGroup',
            ti: 'AnySimpleType'
          }, {
            n: 'imagePyramidObjectExtensionGroup',
            mno: 0,
            col: true,
            en: 'ImagePyramidObjectExtensionGroup',
            ti: '.AbstractObjectType'
          }]
      }, {
        ln: 'AbstractSubStyleType',
        bti: '.AbstractObjectType',
        ps: [{
            n: 'abstractSubStyleSimpleExtensionGroup',
            mno: 0,
            col: true,
            en: 'AbstractSubStyleSimpleExtensionGroup',
            ti: 'AnySimpleType'
          }, {
            n: 'abstractSubStyleObjectExtensionGroup',
            mno: 0,
            col: true,
            en: 'AbstractSubStyleObjectExtensionGroup',
            ti: '.AbstractObjectType'
          }]
      }, {
        ln: 'GroundOverlayType',
        bti: '.AbstractOverlayType',
        ps: [{
            n: 'altitude',
            ti: 'Double'
          }, {
            n: 'altitudeModeGroup',
            mx: false,
            dom: false,
            ti: 'AnyType',
            t: 'er'
          }, {
            n: 'latLonBox',
            en: 'LatLonBox',
            ti: '.LatLonBoxType'
          }, {
            n: 'groundOverlaySimpleExtensionGroup',
            mno: 0,
            col: true,
            en: 'GroundOverlaySimpleExtensionGroup',
            ti: 'AnySimpleType'
          }, {
            n: 'groundOverlayObjectExtensionGroup',
            mno: 0,
            col: true,
            en: 'GroundOverlayObjectExtensionGroup',
            ti: '.AbstractObjectType'
          }]
      }, {
        ln: 'SchemaDataType',
        bti: '.AbstractObjectType',
        ps: [{
            n: 'simpleData',
            mno: 0,
            col: true,
            en: 'SimpleData',
            ti: '.SimpleDataType'
          }, {
            n: 'schemaDataExtension',
            mno: 0,
            col: true,
            en: 'SchemaDataExtension',
            ti: 'AnyType'
          }, {
            n: 'schemaUrl',
            an: {
              lp: 'schemaUrl'
            },
            t: 'a'
          }]
      }, {
        ln: 'LinkType',
        bti: '.BasicLinkType',
        ps: [{
            n: 'refreshMode'
          }, {
            n: 'refreshInterval',
            ti: 'Double'
          }, {
            n: 'viewRefreshMode'
          }, {
            n: 'viewRefreshTime',
            ti: 'Double'
          }, {
            n: 'viewBoundScale',
            ti: 'Double'
          }, {
            n: 'viewFormat'
          }, {
            n: 'httpQuery'
          }, {
            n: 'linkSimpleExtensionGroup',
            mno: 0,
            col: true,
            en: 'LinkSimpleExtensionGroup',
            ti: 'AnySimpleType'
          }, {
            n: 'linkObjectExtensionGroup',
            mno: 0,
            col: true,
            en: 'LinkObjectExtensionGroup',
            ti: '.AbstractObjectType'
          }]
      }, {
        ln: 'BalloonStyleType',
        bti: '.AbstractSubStyleType',
        ps: [{
            n: 'color',
            ti: 'HexBinary'
          }, {
            n: 'bgColor',
            ti: 'HexBinary'
          }, {
            n: 'textColor',
            ti: 'HexBinary'
          }, {
            n: 'text'
          }, {
            n: 'displayMode'
          }, {
            n: 'balloonStyleSimpleExtensionGroup',
            mno: 0,
            col: true,
            en: 'BalloonStyleSimpleExtensionGroup',
            ti: 'AnySimpleType'
          }, {
            n: 'balloonStyleObjectExtensionGroup',
            mno: 0,
            col: true,
            en: 'BalloonStyleObjectExtensionGroup',
            ti: '.AbstractObjectType'
          }]
      }, {
        ln: 'ViewVolumeType',
        bti: '.AbstractObjectType',
        ps: [{
            n: 'leftFov',
            ti: 'Double'
          }, {
            n: 'rightFov',
            ti: 'Double'
          }, {
            n: 'bottomFov',
            ti: 'Double'
          }, {
            n: 'topFov',
            ti: 'Double'
          }, {
            n: 'near',
            ti: 'Double'
          }, {
            n: 'viewVolumeSimpleExtensionGroup',
            mno: 0,
            col: true,
            en: 'ViewVolumeSimpleExtensionGroup',
            ti: 'AnySimpleType'
          }, {
            n: 'viewVolumeObjectExtensionGroup',
            mno: 0,
            col: true,
            en: 'ViewVolumeObjectExtensionGroup',
            ti: '.AbstractObjectType'
          }]
      }, {
        ln: 'UpdateType',
        ps: [{
            n: 'targetHref',
            rq: true
          }, {
            n: 'createOrDeleteOrChange',
            rq: true,
            col: true,
            etis: [{
                en: 'Create',
                ti: '.CreateType'
              }, {
                en: 'Delete',
                ti: '.DeleteType'
              }, {
                en: 'Change',
                ti: '.ChangeType'
              }, {
                en: 'UpdateOpExtensionGroup',
                ti: 'AnyType'
              }],
            t: 'es'
          }, {
            n: 'updateExtensionGroup',
            mno: 0,
            col: true,
            en: 'UpdateExtensionGroup',
            ti: 'AnyType'
          }]
      }, {
        ln: 'IconStyleType',
        bti: '.AbstractColorStyleType',
        ps: [{
            n: 'scale',
            ti: 'Double'
          }, {
            n: 'heading',
            ti: 'Double'
          }, {
            n: 'icon',
            en: 'Icon',
            ti: '.BasicLinkType'
          }, {
            n: 'hotSpot',
            ti: '.Vec2Type'
          }, {
            n: 'iconStyleSimpleExtensionGroup',
            mno: 0,
            col: true,
            en: 'IconStyleSimpleExtensionGroup',
            ti: 'AnySimpleType'
          }, {
            n: 'iconStyleObjectExtensionGroup',
            mno: 0,
            col: true,
            en: 'IconStyleObjectExtensionGroup',
            ti: '.AbstractObjectType'
          }]
      }, {
        ln: 'StyleType',
        bti: '.AbstractStyleSelectorType',
        ps: [{
            n: 'iconStyle',
            en: 'IconStyle',
            ti: '.IconStyleType'
          }, {
            n: 'labelStyle',
            en: 'LabelStyle',
            ti: '.LabelStyleType'
          }, {
            n: 'lineStyle',
            en: 'LineStyle',
            ti: '.LineStyleType'
          }, {
            n: 'polyStyle',
            en: 'PolyStyle',
            ti: '.PolyStyleType'
          }, {
            n: 'balloonStyle',
            en: 'BalloonStyle',
            ti: '.BalloonStyleType'
          }, {
            n: 'listStyle',
            en: 'ListStyle',
            ti: '.ListStyleType'
          }, {
            n: 'styleSimpleExtensionGroup',
            mno: 0,
            col: true,
            en: 'StyleSimpleExtensionGroup',
            ti: 'AnySimpleType'
          }, {
            n: 'styleObjectExtensionGroup',
            mno: 0,
            col: true,
            en: 'StyleObjectExtensionGroup',
            ti: '.AbstractObjectType'
          }]
      }, {
        ln: 'PhotoOverlayType',
        bti: '.AbstractOverlayType',
        ps: [{
            n: 'rotation',
            ti: 'Double'
          }, {
            n: 'viewVolume',
            en: 'ViewVolume',
            ti: '.ViewVolumeType'
          }, {
            n: 'imagePyramid',
            en: 'ImagePyramid',
            ti: '.ImagePyramidType'
          }, {
            n: 'point',
            en: 'Point',
            ti: '.PointType'
          }, {
            n: 'shape'
          }, {
            n: 'photoOverlaySimpleExtensionGroup',
            mno: 0,
            col: true,
            en: 'PhotoOverlaySimpleExtensionGroup',
            ti: 'AnySimpleType'
          }, {
            n: 'photoOverlayObjectExtensionGroup',
            mno: 0,
            col: true,
            en: 'PhotoOverlayObjectExtensionGroup',
            ti: '.AbstractObjectType'
          }]
      }, {
        ln: 'AbstractFeatureType',
        bti: '.AbstractObjectType',
        ps: [{
            n: 'name'
          }, {
            n: 'visibility',
            ti: 'Boolean'
          }, {
            n: 'open',
            ti: 'Boolean'
          }, {
            n: 'atomAuthor',
            en: {
              lp: 'author',
              ns: 'http:\/\/www.w3.org\/2005\/Atom'
            },
            ti: 'Atom_1_0.AtomPersonConstruct'
          }, {
            n: 'atomLink',
            en: {
              lp: 'link',
              ns: 'http:\/\/www.w3.org\/2005\/Atom'
            },
            ti: 'Atom_1_0.Link'
          }, {
            n: 'address'
          }, {
            n: 'addressDetails',
            en: {
              lp: 'AddressDetails',
              ns: 'urn:oasis:names:tc:ciq:xsdschema:xAL:2.0'
            },
            ti: 'xAL_2_0.AddressDetails'
          }, {
            n: 'phoneNumber'
          }, {
            n: 'complexSnippet',
            en: 'Snippet',
            ti: '.SnippetType'
          }, {
            n: 'snippet'
          }, {
            n: 'description'
          }, {
            n: 'abstractViewGroup',
            mx: false,
            dom: false,
            en: 'AbstractViewGroup',
            ti: '.AbstractViewType',
            t: 'er'
          }, {
            n: 'abstractTimePrimitiveGroup',
            mx: false,
            dom: false,
            en: 'AbstractTimePrimitiveGroup',
            ti: '.AbstractTimePrimitiveType',
            t: 'er'
          }, {
            n: 'styleUrl'
          }, {
            n: 'abstractStyleSelectorGroup',
            mno: 0,
            col: true,
            mx: false,
            dom: false,
            en: 'AbstractStyleSelectorGroup',
            ti: '.AbstractStyleSelectorType',
            t: 'er'
          }, {
            n: 'region',
            en: 'Region',
            ti: '.RegionType'
          }, {
            n: 'metadata',
            en: 'Metadata',
            ti: '.MetadataType'
          }, {
            n: 'extendedData',
            en: 'ExtendedData',
            ti: '.ExtendedDataType'
          }, {
            n: 'abstractFeatureSimpleExtensionGroup',
            mno: 0,
            col: true,
            en: 'AbstractFeatureSimpleExtensionGroup',
            ti: 'AnySimpleType'
          }, {
            n: 'abstractFeatureObjectExtensionGroup',
            mno: 0,
            col: true,
            en: 'AbstractFeatureObjectExtensionGroup',
            ti: '.AbstractObjectType'
          }]
      }, {
        ln: 'AbstractColorStyleType',
        bti: '.AbstractSubStyleType',
        ps: [{
            n: 'color',
            ti: 'HexBinary'
          }, {
            n: 'colorMode'
          }, {
            n: 'abstractColorStyleSimpleExtensionGroup',
            mno: 0,
            col: true,
            en: 'AbstractColorStyleSimpleExtensionGroup',
            ti: 'AnySimpleType'
          }, {
            n: 'abstractColorStyleObjectExtensionGroup',
            mno: 0,
            col: true,
            en: 'AbstractColorStyleObjectExtensionGroup',
            ti: '.AbstractObjectType'
          }]
      }, {
        t: 'enum',
        ln: 'ItemIconStateEnumType',
        vs: ['open', 'closed', 'error', 'fetching0', 'fetching1', 'fetching2']
      }, {
        t: 'enum',
        ln: 'DisplayModeEnumType',
        vs: ['default', 'hide']
      }, {
        t: 'enum',
        ln: 'RefreshModeEnumType',
        vs: ['onChange', 'onInterval', 'onExpire']
      }, {
        t: 'enum',
        ln: 'GridOriginEnumType',
        vs: ['lowerLeft', 'upperLeft']
      }, {
        t: 'enum',
        ln: 'ListItemTypeEnumType',
        vs: ['radioFolder', 'check', 'checkHideChildren', 'checkOffOnly']
      }, {
        t: 'enum',
        ln: 'StyleStateEnumType',
        vs: ['normal', 'highlight']
      }, {
        t: 'enum',
        ln: 'ColorModeEnumType',
        vs: ['normal', 'random']
      }, {
        t: 'enum',
        ln: 'ViewRefreshModeEnumType',
        vs: ['never', 'onRequest', 'onStop', 'onRegion']
      }, {
        t: 'enum',
        ln: 'AltitudeModeEnumType',
        vs: ['clampToGround', 'relativeToGround', 'absolute']
      }, {
        t: 'enum',
        ln: 'UnitsEnumType',
        vs: ['fraction', 'pixels', 'insetPixels']
      }, {
        t: 'enum',
        ln: 'ShapeEnumType',
        vs: ['rectangle', 'cylinder', 'sphere']
      }],
    eis: [{
        en: 'LocationObjectExtensionGroup',
        ti: '.AbstractObjectType',
        sh: 'AbstractObjectGroup'
      }, {
        en: 'AbstractFeatureSimpleExtensionGroup',
        ti: 'AnySimpleType'
      }, {
        en: 'hotSpot',
        ti: '.Vec2Type'
      }, {
        en: 'CameraSimpleExtensionGroup',
        ti: 'AnySimpleType'
      }, {
        en: 'AbstractOverlaySimpleExtensionGroup',
        ti: 'AnySimpleType'
      }, {
        en: 'FolderObjectExtensionGroup',
        ti: '.AbstractObjectType',
        sh: 'AbstractObjectGroup'
      }, {
        en: 'maxAltitude',
        ti: 'Double'
      }, {
        en: 'AbstractTimePrimitiveSimpleExtensionGroup',
        ti: 'AnySimpleType'
      }, {
        en: 'PointObjectExtensionGroup',
        ti: '.AbstractObjectType',
        sh: 'AbstractObjectGroup'
      }, {
        en: 'linkName'
      }, {
        en: 'StyleMapSimpleExtensionGroup',
        ti: 'AnySimpleType'
      }, {
        en: 'roll',
        ti: 'Double'
      }, {
        en: 'Folder',
        ti: '.FolderType',
        sh: 'AbstractContainerGroup'
      }, {
        en: 'tessellate',
        ti: 'Boolean'
      }, {
        en: 'AbstractTimePrimitiveGroup',
        ti: '.AbstractTimePrimitiveType',
        sh: 'AbstractObjectGroup'
      }, {
        en: 'NetworkLinkSimpleExtensionGroup',
        ti: 'AnySimpleType'
      }, {
        en: 'viewFormat'
      }, {
        en: 'Snippet',
        ti: '.SnippetType'
      }, {
        en: 'DocumentObjectExtensionGroup',
        ti: '.AbstractObjectType',
        sh: 'AbstractObjectGroup'
      }, {
        en: 'TimeStamp',
        ti: '.TimeStampType',
        sh: 'AbstractTimePrimitiveGroup'
      }, {
        en: 'altitudeMode',
        sh: 'altitudeModeGroup'
      }, {
        en: 'visibility',
        ti: 'Boolean'
      }, {
        en: 'snippet'
      }, {
        en: 'AbstractContainerSimpleExtensionGroup',
        ti: 'AnySimpleType'
      }, {
        en: 'BasicLinkObjectExtensionGroup',
        ti: '.AbstractObjectType',
        sh: 'AbstractObjectGroup'
      }, {
        en: 'AbstractViewGroup',
        ti: '.AbstractViewType',
        sh: 'AbstractObjectGroup'
      }, {
        en: 'AbstractContainerGroup',
        ti: '.AbstractContainerType',
        sh: 'AbstractFeatureGroup'
      }, {
        en: 'LookAtObjectExtensionGroup',
        ti: '.AbstractObjectType',
        sh: 'AbstractObjectGroup'
      }, {
        en: 'Data',
        ti: '.DataType',
        sh: 'AbstractObjectGroup'
      }, {
        en: 'ImagePyramidSimpleExtensionGroup',
        ti: 'AnySimpleType'
      }, {
        en: 'y',
        ti: 'Double'
      }, {
        en: 'MultiGeometryObjectExtensionGroup',
        ti: '.AbstractObjectType',
        sh: 'AbstractObjectGroup'
      }, {
        en: 'ListStyle',
        ti: '.ListStyleType',
        sh: 'AbstractSubStyleGroup'
      }, {
        en: 'ViewVolumeObjectExtensionGroup',
        ti: '.AbstractObjectType',
        sh: 'AbstractObjectGroup'
      }, {
        en: 'styleUrl'
      }, {
        en: 'ModelSimpleExtensionGroup',
        ti: 'AnySimpleType'
      }, {
        en: 'z',
        ti: 'Double'
      }, {
        en: 'tilt',
        ti: 'Double'
      }, {
        en: 'NetworkLinkControlObjectExtensionGroup',
        ti: '.AbstractObjectType',
        sh: 'AbstractObjectGroup'
      }, {
        en: 'LodObjectExtensionGroup',
        ti: '.AbstractObjectType',
        sh: 'AbstractObjectGroup'
      }, {
        en: 'maxLodPixels',
        ti: 'Double'
      }, {
        en: 'PointSimpleExtensionGroup',
        ti: 'AnySimpleType'
      }, {
        en: 'topFov',
        ti: 'Double'
      }, {
        en: 'heading',
        ti: 'Double'
      }, {
        en: 'ListStyleObjectExtensionGroup',
        ti: '.AbstractObjectType',
        sh: 'AbstractObjectGroup'
      }, {
        en: 'bottomFov',
        ti: 'Double'
      }, {
        en: 'LodSimpleExtensionGroup',
        ti: 'AnySimpleType'
      }, {
        en: 'TimeStampSimpleExtensionGroup',
        ti: 'AnySimpleType'
      }, {
        en: 'screenXY',
        ti: '.Vec2Type'
      }, {
        en: 'linkDescription'
      }, {
        en: 'LatLonBoxSimpleExtensionGroup',
        ti: 'AnySimpleType'
      }, {
        en: 'LocationSimpleExtensionGroup',
        ti: 'AnySimpleType'
      }, {
        en: 'south',
        ti: 'Double'
      }, {
        en: 'width',
        ti: 'Double'
      }, {
        en: 'coordinates',
        ti: {
          t: 'l'
        }
      }, {
        en: 'AliasSimpleExtensionGroup',
        ti: 'AnySimpleType'
      }, {
        en: 'Schema',
        ti: '.SchemaType'
      }, {
        en: 'LabelStyleSimpleExtensionGroup',
        ti: 'AnySimpleType'
      }, {
        en: 'DocumentSimpleExtensionGroup',
        ti: 'AnySimpleType'
      }, {
        en: 'overlayXY',
        ti: '.Vec2Type'
      }, {
        en: 'StyleObjectExtensionGroup',
        ti: '.AbstractObjectType',
        sh: 'AbstractObjectGroup'
      }, {
        en: 'AbstractSubStyleObjectExtensionGroup',
        ti: '.AbstractObjectType',
        sh: 'AbstractObjectGroup'
      }, {
        en: 'viewRefreshMode'
      }, {
        en: 'Point',
        ti: '.PointType',
        sh: 'AbstractGeometryGroup'
      }, {
        en: 'shape'
      }, {
        en: 'kml',
        ti: '.KmlType'
      }, {
        en: 'ResourceMapObjectExtensionGroup',
        ti: '.AbstractObjectType',
        sh: 'AbstractObjectGroup'
      }, {
        en: 'bgColor',
        ti: 'HexBinary'
      }, {
        en: 'AbstractContainerObjectExtensionGroup',
        ti: '.AbstractObjectType',
        sh: 'AbstractObjectGroup'
      }, {
        en: 'longitude',
        ti: 'Double'
      }, {
        en: 'north',
        ti: 'Double'
      }, {
        en: 'ScaleSimpleExtensionGroup',
        ti: 'AnySimpleType'
      }, {
        en: 'TimeStampObjectExtensionGroup',
        ti: '.AbstractObjectType',
        sh: 'AbstractObjectGroup'
      }, {
        en: 'ImagePyramid',
        ti: '.ImagePyramidType',
        sh: 'AbstractObjectGroup'
      }, {
        en: 'color',
        ti: 'HexBinary'
      }, {
        en: 'listItemType'
      }, {
        en: 'LatLonBox',
        ti: '.LatLonBoxType',
        sh: 'AbstractObjectGroup'
      }, {
        en: 'TimeSpan',
        ti: '.TimeSpanType',
        sh: 'AbstractTimePrimitiveGroup'
      }, {
        en: 'minRefreshPeriod',
        ti: 'Double'
      }, {
        en: 'range',
        ti: 'Double'
      }, {
        en: 'LabelStyle',
        ti: '.LabelStyleType',
        sh: 'AbstractColorStyleGroup'
      }, {
        en: 'Pair',
        ti: '.PairType',
        sh: 'AbstractObjectGroup'
      }, {
        en: 'BoundarySimpleExtensionGroup',
        ti: 'AnySimpleType'
      }, {
        en: 'ScaleObjectExtensionGroup',
        ti: '.AbstractObjectType',
        sh: 'AbstractObjectGroup'
      }, {
        en: 'cookie'
      }, {
        en: 'ExtendedData',
        ti: '.ExtendedDataType'
      }, {
        en: 'SimpleField',
        ti: '.SimpleFieldType'
      }, {
        en: 'NetworkLinkControl',
        ti: '.NetworkLinkControlType'
      }, {
        en: 'PhotoOverlaySimpleExtensionGroup',
        ti: 'AnySimpleType'
      }, {
        en: 'Region',
        ti: '.RegionType',
        sh: 'AbstractObjectGroup'
      }, {
        en: 'LinkObjectExtensionGroup',
        ti: '.AbstractObjectType',
        sh: 'AbstractObjectGroup'
      }, {
        en: 'AbstractOverlayGroup',
        ti: '.AbstractOverlayType',
        sh: 'AbstractFeatureGroup'
      }, {
        en: 'Orientation',
        ti: '.OrientationType',
        sh: 'AbstractObjectGroup'
      }, {
        en: 'AbstractFeatureObjectExtensionGroup',
        ti: '.AbstractObjectType',
        sh: 'AbstractObjectGroup'
      }, {
        en: 'rotation',
        ti: 'Double'
      }, {
        en: 'ViewVolume',
        ti: '.ViewVolumeType',
        sh: 'AbstractObjectGroup'
      }, {
        en: 'displayMode'
      }, {
        en: 'AbstractStyleSelectorSimpleExtensionGroup',
        ti: 'AnySimpleType'
      }, {
        en: 'Polygon',
        ti: '.PolygonType',
        sh: 'AbstractGeometryGroup'
      }, {
        en: 'PlacemarkObjectExtensionGroup',
        ti: '.AbstractObjectType',
        sh: 'AbstractObjectGroup'
      }, {
        en: 'ItemIconSimpleExtensionGroup',
        ti: 'AnySimpleType'
      }, {
        en: 'AbstractColorStyleObjectExtensionGroup',
        ti: '.AbstractObjectType',
        sh: 'AbstractObjectGroup'
      }, {
        en: 'name'
      }, {
        en: 'MultiGeometry',
        ti: '.MultiGeometryType',
        sh: 'AbstractGeometryGroup'
      }, {
        en: 'AliasObjectExtensionGroup',
        ti: '.AbstractObjectType',
        sh: 'AbstractObjectGroup'
      }, {
        en: 'targetHref'
      }, {
        en: 'tileSize',
        ti: 'Int'
      }, {
        en: 'UpdateExtensionGroup',
        ti: 'AnyType'
      }, {
        en: 'MultiGeometrySimpleExtensionGroup',
        ti: 'AnySimpleType'
      }, {
        en: 'IconStyle',
        ti: '.IconStyleType',
        sh: 'AbstractColorStyleGroup'
      }, {
        en: 'LatLonAltBoxObjectExtensionGroup',
        ti: '.AbstractObjectType',
        sh: 'AbstractObjectGroup'
      }, {
        en: 'Icon',
        ti: '.LinkType',
        sh: 'AbstractObjectGroup'
      }, {
        en: 'minLodPixels',
        ti: 'Double'
      }, {
        en: 'BoundaryObjectExtensionGroup',
        ti: '.AbstractObjectType',
        sh: 'AbstractObjectGroup'
      }, {
        en: 'LinkSimpleExtensionGroup',
        ti: 'AnySimpleType'
      }, {
        en: 'text'
      }, {
        en: 'LinearRing',
        ti: '.LinearRingType',
        sh: 'AbstractGeometryGroup'
      }, {
        en: 'sourceHref'
      }, {
        en: 'fill',
        ti: 'Boolean'
      }, {
        en: 'LineStyle',
        ti: '.LineStyleType',
        sh: 'AbstractColorStyleGroup'
      }, {
        en: 'Lod',
        ti: '.LodType',
        sh: 'AbstractObjectGroup'
      }, {
        en: 'AbstractLatLonBoxSimpleExtensionGroup',
        ti: 'AnySimpleType'
      }, {
        en: 'Style',
        ti: '.StyleType',
        sh: 'AbstractStyleSelectorGroup'
      }, {
        en: 'GroundOverlayObjectExtensionGroup',
        ti: '.AbstractObjectType',
        sh: 'AbstractObjectGroup'
      }, {
        en: 'GroundOverlaySimpleExtensionGroup',
        ti: 'AnySimpleType'
      }, {
        en: 'extrude',
        ti: 'Boolean'
      }, {
        en: 'OrientationSimpleExtensionGroup',
        ti: 'AnySimpleType'
      }, {
        en: 'SimpleFieldExtension',
        ti: 'AnyType'
      }, {
        en: 'ViewVolumeSimpleExtensionGroup',
        ti: 'AnySimpleType'
      }, {
        en: 'maxSessionLength',
        ti: 'Double'
      }, {
        en: 'colorMode'
      }, {
        en: 'value'
      }, {
        en: 'ImagePyramidObjectExtensionGroup',
        ti: '.AbstractObjectType',
        sh: 'AbstractObjectGroup'
      }, {
        en: 'StyleSimpleExtensionGroup',
        ti: 'AnySimpleType'
      }, {
        en: 'AbstractObjectGroup',
        ti: '.AbstractObjectType'
      }, {
        en: 'maxHeight',
        ti: 'Int'
      }, {
        en: 'PairObjectExtensionGroup',
        ti: '.AbstractObjectType',
        sh: 'AbstractObjectGroup'
      }, {
        en: 'PhotoOverlayObjectExtensionGroup',
        ti: '.AbstractObjectType',
        sh: 'AbstractObjectGroup'
      }, {
        en: 'ListStyleSimpleExtensionGroup',
        ti: 'AnySimpleType'
      }, {
        en: 'PhotoOverlay',
        ti: '.PhotoOverlayType',
        sh: 'AbstractOverlayGroup'
      }, {
        en: 'AbstractColorStyleSimpleExtensionGroup',
        ti: 'AnySimpleType'
      }, {
        en: 'address'
      }, {
        en: 'AbstractFeatureGroup',
        ti: '.AbstractFeatureType',
        sh: 'AbstractObjectGroup'
      }, {
        en: 'TimeSpanObjectExtensionGroup',
        ti: '.AbstractObjectType',
        sh: 'AbstractObjectGroup'
      }, {
        en: 'x',
        ti: 'Double'
      }, {
        en: 'UpdateOpExtensionGroup',
        ti: 'AnyType'
      }, {
        en: 'textColor',
        ti: 'HexBinary'
      }, {
        en: 'when'
      }, {
        en: 'displayName'
      }, {
        en: 'state',
        ti: {
          t: 'l'
        }
      }, {
        en: 'innerBoundaryIs',
        ti: '.BoundaryType'
      }, {
        en: 'AbstractViewObjectExtensionGroup',
        ti: '.AbstractObjectType',
        sh: 'AbstractObjectGroup'
      }, {
        en: 'AbstractViewSimpleExtensionGroup',
        ti: 'AnySimpleType'
      }, {
        en: 'end'
      }, {
        en: 'LookAt',
        ti: '.LookAtType',
        sh: 'AbstractViewGroup'
      }, {
        en: 'NetworkLink',
        ti: '.NetworkLinkType',
        sh: 'AbstractFeatureGroup'
      }, {
        en: 'outerBoundaryIs',
        ti: '.BoundaryType'
      }, {
        en: 'LineStyleObjectExtensionGroup',
        ti: '.AbstractObjectType',
        sh: 'AbstractObjectGroup'
      }, {
        en: 'GroundOverlay',
        ti: '.GroundOverlayType',
        sh: 'AbstractOverlayGroup'
      }, {
        en: 'key'
      }, {
        en: 'maxSnippetLines',
        ti: 'Int'
      }, {
        en: 'AbstractColorStyleGroup',
        ti: '.AbstractColorStyleType',
        sh: 'AbstractSubStyleGroup'
      }, {
        en: 'altitudeModeGroup',
        ti: 'AnyType'
      }, {
        en: 'minFadeExtent',
        ti: 'Double'
      }, {
        en: 'LineStringSimpleExtensionGroup',
        ti: 'AnySimpleType'
      }, {
        en: 'RegionSimpleExtensionGroup',
        ti: 'AnySimpleType'
      }, {
        en: 'ObjectSimpleExtensionGroup',
        ti: 'AnySimpleType'
      }, {
        en: 'SchemaDataExtension',
        ti: 'AnyType'
      }, {
        en: 'httpQuery'
      }, {
        en: 'IconStyleSimpleExtensionGroup',
        ti: 'AnySimpleType'
      }, {
        en: 'Create',
        ti: '.CreateType'
      }, {
        en: 'ResourceMapSimpleExtensionGroup',
        ti: 'AnySimpleType'
      }, {
        en: 'Link',
        ti: '.LinkType',
        sh: 'AbstractObjectGroup'
      }, {
        en: 'refreshMode'
      }, {
        en: 'open',
        ti: 'Boolean'
      }, {
        en: 'near',
        ti: 'Double'
      }, {
        en: 'RegionObjectExtensionGroup',
        ti: '.AbstractObjectType',
        sh: 'AbstractObjectGroup'
      }, {
        en: 'AbstractGeometryObjectExtensionGroup',
        ti: '.AbstractObjectType',
        sh: 'AbstractObjectGroup'
      }, {
        en: 'PolyStyle',
        ti: '.PolyStyleType',
        sh: 'AbstractColorStyleGroup'
      }, {
        en: 'FolderSimpleExtensionGroup',
        ti: 'AnySimpleType'
      }, {
        en: 'altitude',
        ti: 'Double'
      }, {
        en: 'PolygonSimpleExtensionGroup',
        ti: 'AnySimpleType'
      }, {
        en: 'Camera',
        ti: '.CameraType',
        sh: 'AbstractViewGroup'
      }, {
        en: 'IconStyleObjectExtensionGroup',
        ti: '.AbstractObjectType',
        sh: 'AbstractObjectGroup'
      }, {
        en: 'StyleMapObjectExtensionGroup',
        ti: '.AbstractObjectType',
        sh: 'AbstractObjectGroup'
      }, {
        en: 'ScreenOverlayObjectExtensionGroup',
        ti: '.AbstractObjectType',
        sh: 'AbstractObjectGroup'
      }, {
        en: 'begin'
      }, {
        en: 'Location',
        ti: '.LocationType',
        sh: 'AbstractObjectGroup'
      }, {
        en: 'LabelStyleObjectExtensionGroup',
        ti: '.AbstractObjectType',
        sh: 'AbstractObjectGroup'
      }, {
        en: 'ScreenOverlay',
        ti: '.ScreenOverlayType',
        sh: 'AbstractOverlayGroup'
      }, {
        en: 'CameraObjectExtensionGroup',
        ti: '.AbstractObjectType',
        sh: 'AbstractObjectGroup'
      }, {
        en: 'ScreenOverlaySimpleExtensionGroup',
        ti: 'AnySimpleType'
      }, {
        en: 'expires'
      }, {
        en: 'maxFadeExtent',
        ti: 'Double'
      }, {
        en: 'Url',
        ti: '.LinkType',
        sh: 'AbstractObjectGroup'
      }, {
        en: 'phoneNumber'
      }, {
        en: 'StyleMap',
        ti: '.StyleMapType',
        sh: 'AbstractStyleSelectorGroup'
      }, {
        en: 'PolyStyleObjectExtensionGroup',
        ti: '.AbstractObjectType',
        sh: 'AbstractObjectGroup'
      }, {
        en: 'NetworkLinkObjectExtensionGroup',
        ti: '.AbstractObjectType',
        sh: 'AbstractObjectGroup'
      }, {
        en: 'refreshVisibility',
        ti: 'Boolean'
      }, {
        en: 'Model',
        ti: '.ModelType',
        sh: 'AbstractGeometryGroup'
      }, {
        en: 'latitude',
        ti: 'Double'
      }, {
        en: 'scale',
        ti: 'Double'
      }, {
        en: 'SimpleData',
        ti: '.SimpleDataType'
      }, {
        en: 'drawOrder',
        ti: 'Int'
      }, {
        en: 'east',
        ti: 'Double'
      }, {
        en: 'Placemark',
        ti: '.PlacemarkType',
        sh: 'AbstractFeatureGroup'
      }, {
        en: 'LookAtSimpleExtensionGroup',
        ti: 'AnySimpleType'
      }, {
        en: 'AbstractLatLonBoxObjectExtensionGroup',
        ti: '.AbstractObjectType',
        sh: 'AbstractObjectGroup'
      }, {
        en: 'AbstractSubStyleGroup',
        ti: '.AbstractSubStyleType',
        sh: 'AbstractObjectGroup'
      }, {
        en: 'Metadata',
        ti: '.MetadataType'
      }, {
        en: 'size',
        ti: '.Vec2Type'
      }, {
        en: 'AbstractStyleSelectorGroup',
        ti: '.AbstractStyleSelectorType',
        sh: 'AbstractObjectGroup'
      }, {
        en: 'LatLonAltBoxSimpleExtensionGroup',
        ti: 'AnySimpleType'
      }, {
        en: 'AbstractGeometrySimpleExtensionGroup',
        ti: 'AnySimpleType'
      }, {
        en: 'LatLonAltBox',
        ti: '.LatLonAltBoxType',
        sh: 'AbstractObjectGroup'
      }, {
        en: 'rotationXY',
        ti: '.Vec2Type'
      }, {
        en: 'leftFov',
        ti: 'Double'
      }, {
        en: 'LinearRingSimpleExtensionGroup',
        ti: 'AnySimpleType'
      }, {
        en: 'linkSnippet',
        ti: '.SnippetType'
      }, {
        en: 'KmlSimpleExtensionGroup',
        ti: 'AnySimpleType'
      }, {
        en: 'outline',
        ti: 'Boolean'
      }, {
        en: 'ItemIcon',
        ti: '.ItemIconType',
        sh: 'AbstractObjectGroup'
      }, {
        en: 'AbstractGeometryGroup',
        ti: '.AbstractGeometryType',
        sh: 'AbstractObjectGroup'
      }, {
        en: 'KmlObjectExtensionGroup',
        ti: '.AbstractObjectType',
        sh: 'AbstractObjectGroup'
      }, {
        en: 'west',
        ti: 'Double'
      }, {
        en: 'SchemaExtension',
        ti: 'AnyType'
      }, {
        en: 'AbstractTimePrimitiveObjectExtensionGroup',
        ti: '.AbstractObjectType',
        sh: 'AbstractObjectGroup'
      }, {
        en: 'Alias',
        ti: '.AliasType',
        sh: 'AbstractObjectGroup'
      }, {
        en: 'AbstractStyleSelectorObjectExtensionGroup',
        ti: '.AbstractObjectType',
        sh: 'AbstractObjectGroup'
      }, {
        en: 'LineStyleSimpleExtensionGroup',
        ti: 'AnySimpleType'
      }, {
        en: 'viewRefreshTime',
        ti: 'Double'
      }, {
        en: 'href'
      }, {
        en: 'viewBoundScale',
        ti: 'Double'
      }, {
        en: 'TimeSpanSimpleExtensionGroup',
        ti: 'AnySimpleType'
      }, {
        en: 'BalloonStyleSimpleExtensionGroup',
        ti: 'AnySimpleType'
      }, {
        en: 'description'
      }, {
        en: 'rightFov',
        ti: 'Double'
      }, {
        en: 'Change',
        ti: '.ChangeType'
      }, {
        en: 'LineStringObjectExtensionGroup',
        ti: '.AbstractObjectType',
        sh: 'AbstractObjectGroup'
      }, {
        en: 'PolyStyleSimpleExtensionGroup',
        ti: 'AnySimpleType'
      }, {
        en: 'refreshInterval',
        ti: 'Double'
      }, {
        en: 'Scale',
        ti: '.ScaleType',
        sh: 'AbstractObjectGroup'
      }, {
        en: 'Delete',
        ti: '.DeleteType'
      }, {
        en: 'Document',
        ti: '.DocumentType',
        sh: 'AbstractContainerGroup'
      }, {
        en: 'AbstractSubStyleSimpleExtensionGroup',
        ti: 'AnySimpleType'
      }, {
        en: 'PairSimpleExtensionGroup',
        ti: 'AnySimpleType'
      }, {
        en: 'maxWidth',
        ti: 'Int'
      }, {
        en: 'BalloonStyle',
        ti: '.BalloonStyleType',
        sh: 'AbstractSubStyleGroup'
      }, {
        en: 'DataExtension',
        ti: 'AnyType'
      }, {
        en: 'BalloonStyleObjectExtensionGroup',
        ti: '.AbstractObjectType',
        sh: 'AbstractObjectGroup'
      }, {
        en: 'LinearRingObjectExtensionGroup',
        ti: '.AbstractObjectType',
        sh: 'AbstractObjectGroup'
      }, {
        en: 'OrientationObjectExtensionGroup',
        ti: '.AbstractObjectType',
        sh: 'AbstractObjectGroup'
      }, {
        en: 'SchemaData',
        ti: '.SchemaDataType',
        sh: 'AbstractObjectGroup'
      }, {
        en: 'PlacemarkSimpleExtensionGroup',
        ti: 'AnySimpleType'
      }, {
        en: 'LatLonBoxObjectExtensionGroup',
        ti: '.AbstractObjectType',
        sh: 'AbstractObjectGroup'
      }, {
        en: 'LineString',
        ti: '.LineStringType',
        sh: 'AbstractGeometryGroup'
      }, {
        en: 'flyToView',
        ti: 'Boolean'
      }, {
        en: 'minAltitude',
        ti: 'Double'
      }, {
        en: 'AbstractOverlayObjectExtensionGroup',
        ti: '.AbstractObjectType',
        sh: 'AbstractObjectGroup'
      }, {
        en: 'Update',
        ti: '.UpdateType'
      }, {
        en: 'BasicLinkSimpleExtensionGroup',
        ti: 'AnySimpleType'
      }, {
        en: 'NetworkLinkControlSimpleExtensionGroup',
        ti: 'AnySimpleType'
      }, {
        en: 'ModelObjectExtensionGroup',
        ti: '.AbstractObjectType',
        sh: 'AbstractObjectGroup'
      }, {
        en: 'ResourceMap',
        ti: '.ResourceMapType',
        sh: 'AbstractObjectGroup'
      }, {
        en: 'message'
      }, {
        en: 'ItemIconObjectExtensionGroup',
        ti: '.AbstractObjectType',
        sh: 'AbstractObjectGroup'
      }, {
        en: 'gridOrigin'
      }, {
        en: 'PolygonObjectExtensionGroup',
        ti: '.AbstractObjectType',
        sh: 'AbstractObjectGroup'
      }]
  };
  return {
    KML_2_2_0: KML_2_2_0
  };
};
if (typeof define === 'function' && define.amd) {
  define([], KML_2_2_0_Module_Factory);
}
else {
  var KML_2_2_0_Module = KML_2_2_0_Module_Factory();
  if (typeof module !== 'undefined' && module.exports) {
    module.exports.KML_2_2_0 = KML_2_2_0_Module.KML_2_2_0;
  }
  else {
    var KML_2_2_0 = KML_2_2_0_Module.KML_2_2_0;
  }
}